import { render, staticRenderFns } from "./FilePopup.vue?vue&type=template&id=bda4559c&"
import script from "./FilePopup.vue?vue&type=script&lang=js&"
export * from "./FilePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports